<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastroDomiciliar"
        ref="DataTable"
        sort-by="logradouroNome"
    >

        <template v-slot:cell(dataExportacao)="{ item }">

            <span v-if="item.dataExportacao">
                {{ item.dataExportacao }} às {{ item.horarioExportacao }} - {{ item.profissionalExportacao }}
            </span>
            <span v-else>-</span>
        </template>

        <template v-slot:cell(actions)="{ item }">

            <rkm-button
                color="primary"
                small
                title="Visualizar"
                @click.stop="$router.push({ name: 'atencao-basica-cadastro-domiciliar-edit', params: { id: item.id } })"
            >
                <rkm-icon icon="search" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
import { repository, error, object, formats, data, stringCase, mask, unmask } from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {
                    key: "nomeMorador",
                    label: "Nome Morador",
                    name: 'nomeMorador',
                    searchable: true,
                    sortable: false,
                    visible: false
                },
                                {
                    key: "nomeSocial",
                    label: "Nome Social",
                    name: 'nomeSocial',
                    searchable: true,
                    sortable: false,
                    visible: false
                },
                {
                    key: "responsavelFamiliar",
                    label: "Responsável Familiar",
                    name: 'responsavelFamiliar',
                    searchable: true,
                    sortable: false,
                    visible: false
                },
                {
                    key: "cpf",
                    label: "CPF",
                    name: 'cpf',
                    searchable: true,
                    sortable: false,
                    visible: false
                },
                {
                    key: "cns",
                    label: "CNS",
                    name: 'cns',
                    searchable: true,
                    sortable: false,
                    visible: false
                },
                {
                    key: "nascimento",
                    label: "Data de Nascimento",
                    name: 'nascimento',
                    searchable: true,
                    sortable: false,
                    visible: false
                },
                {
                    key: "prontuario",
                    label: "Prontuário",
                    name: 'prontuario',
                    searchable: true,
                    sortable: false,
                    visible: false
                },
                {
                    key: "logradouroTipoDescricao",
                    label: "Tipo de logradouro",
                    name: 'cadastroLogradouroTipo.descricao',
                    searchable: true,
                    sortable: true
                },
                {
                    key: "logradouroNome",
                    label: "Logradouro",
                    name: 'cadastroLogradouro.nome',
                    searchable: true,
                    sortable: true
                },
                {
                    key: "enderecoNumero",
                    label: "Número",
                    name: 'cadastroEndereco.numero',
                    searchable: true,
                    sortable: true
                },
                {
                    key: "bairro",
                    label: "Bairro",
                    name: 'cadastroBairro.nome',
                    searchable: true,
                    sortable: true
                },
                {
                    key: "logradouroCep",
                    label: "CEP",
                    name: 'cadastroLogradouro.cep',
                    searchable: true,
                    sortable: true
                },
                {
                    key: "loteamentoNome",
                    label: "Loteamento / Subdistrito",
                    name: 'cadastroLoteamento.nome',
                    searchable: true,
                    sortable: true
                },
                {
                    key: "enderecoComplemento",
                    label: "Complemento",
                    name: 'cadastroEndereco.complemento',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'dataExportacao',
                    label: 'Exportação',
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                }
            ];
        },
    },
    created() {

        this.repositories = {
            cadastroDomiciliar: this.getConectaSusRepository('atencaoBasica.cadastroDomiciliar'),
            logradouro: this.getConectaSusRepository('cadastro.localizacao.logradouro')
        };
    },
    mixins: [repository, error, object, formats, data, stringCase, mask, unmask],
}
</script>